enum ResidencyUses {
	None = 0,
	Household = 1,
	Business = 2,
}

export default ResidencyUses;
